module.exports = __webpack_public_path__ + "img/frame.9b9578b0.webp";